import { render, staticRenderFns } from "./file_uploader.vue?vue&type=template&id=4d122981&scoped=true&"
import script from "./file_uploader.vue?vue&type=script&lang=js&"
export * from "./file_uploader.vue?vue&type=script&lang=js&"
import style0 from "./file_uploader.vue?vue&type=style&index=0&id=4d122981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d122981",
  null
  
)

export default component.exports